import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../../api';
import { MaterialItem } from '../types';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getMaterials: builder.query<MaterialItem[], void>({
      query: () => ({
        url: '/v1/Material',
      }),
    }),
    getMaterialDetail: builder.query<MaterialItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/Material/${data.id}`,
      }),
    }),
    changeMaterial: builder.mutation<void, MaterialItem>({
      query: (data) => ({
        url: `/v1/Material/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    createMaterial: builder.mutation<void, MaterialItem>({
      query: (data) => ({
        url: '/v1/Material',
        method: 'POST',
        body: data,
      }),
    }),
    deleteMaterial: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/Material/${data.id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useChangeMaterialMutation,
  useCreateMaterialMutation,
  useDeleteMaterialMutation,
  useGetMaterialDetailQuery,
  useLazyGetMaterialDetailQuery,
  useLazyGetMaterialsQuery,
  useGetMaterialsQuery,
} = request;
